import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';
import type { ScaleBand } from 'd3';
import type { Config } from './types';
import './x-axis-label.scss';

type Props = {
  id: string | number;
  label: ReactNode;
  xAxis: ScaleBand<string | number>;
  config: Config;
  totalLabels: number;
};

export default function XAxisLabel({ id, label, xAxis, config, totalLabels }: Props): ReactElement {
  function xAxisPosition(): number {
    if (config.xAxis.label.writingMode === 'vertical-lr') {
      return xAxis(id);
    }
    return xAxis(id) - xAxis.bandwidth() + xAxis.padding() * xAxis.bandwidth();
  }

  function labelInlineStyles(): { width: number; fontSize: number } | undefined {
    if (config.xAxis.label.writingMode === 'vertical-lr') {
      return {
        width: xAxis.bandwidth(),
        fontSize: totalLabels < 10 ? 14 : 11 // Reduce font size as more labels are added.
      };
    }
    return undefined;
  }

  const labelClasses = clsx({
    'pt-3 p-2 text-center': config.xAxis.label.writingMode === 'horizontal-tb',
    'vertical-lr': config.xAxis.label.writingMode === 'vertical-lr'
  });

  return (
    <foreignObject
      key={id}
      width={xAxis.bandwidth() + xAxis.padding() * xAxis.bandwidth() * 2}
      height={config.margin.bottom || config.margin.default}
      x={xAxisPosition()}
      className="x-axis-label-container"
    >
      <div className={labelClasses} style={labelInlineStyles()}>
        {label}
      </div>
    </foreignObject>
  );
}
